export default "__VITE_ASSET__CM2Yt$hP__"